<template>
    <!--<div class="app-wrapper" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">-->
    <div class="app-wrapper">
        <nav-bar></nav-bar>
        <div class="main-container">
            <app-main></app-main>
        </div>
        <!--<response-footer></response-footer>-->
        <router-view name="footer"></router-view>
    </div>
</template>

<script>

    import NavBar from '@/components/NewNavBar';
    // import NavBar from '@/components/qidaiNavBar';
    import AppMain from '@/components/AppMain';
    import ResponseFooter from "components/response-footer";

    export default {
        name: "layout",
        components: {
            NavBar,
            AppMain,
            ResponseFooter
        },
        computed:{
            allowScroll(){
                return this.$store.state.allowScroll;
            },
            wapNavIsShow(){
                return this.$store.state.wapNavIsShow;
            },
        },
        data(){
            return{
                // allowScroll: true,
                touchStartY: 0,
            }
        },
        created(){
            // document.addEventListener('touchmove', this.controlScroll, {passive: false});
        },
        methods: {
            handleTouchStart(e){
                if(this.$store.state.isPc){
                    return;
                }else{
                    this.touchStartY = e.changedTouches[0].pageY;
                    // document.addEventListener('touchmove', this.controlScroll, {passive: false});
                }    
            },
            handleTouchMove(e){
                if(this.$store.state.isPc){
                    return;
                }else{
                    if(this.wapNavIsShow){

                        let ulHeight = $(".nav-main").height();
                        let scrollTop = $(".nav-main").scrollTop();
                        let scrollheight = $(".nav-main")[0].scrollHeight;

                        if((ulHeight+scrollTop) / scrollheight > 0.98 && e.changedTouches[0].pageY < this.touchStartY){
                            if(this.allowScroll){
                                this.$store.commit('setAllowScroll', false);
                            }

                        }else if(scrollTop == 0 && e.changedTouches[0].pageY > this.touchStartY){
                            this.$store.commit('setAllowScroll', false);
                            
                        }else{
                            if(!this.allowScroll){
                                this.$store.commit('setAllowScroll', true);
                            }
                        }
                    }else{

                        if(e.changedTouches[0].pageY > this.touchStartY && window.scrollY == 0){
                            if(this.allowScroll){
                                // this.allowScroll = false;
                                this.$store.commit('setAllowScroll', false);
                                // document.addEventListener('touchmove', this.disableScroll, {passive: false});
                            }
                        }else{
                            if(!this.allowScroll){
                                // this.allowScroll = true;
                                this.$store.commit('setAllowScroll', true);
                                // document.addEventListener('touchmove', this.enableScroll, {passive: false});
                            }
                        }
                    }
                }
            },
            handleTouchEnd(e){
                if(this.$store.state.isPc){
                    return;
                }else{
                    // document.removeEventListener('touchmove', this.controlScroll, {passive: false});
                }
            },
            controlScroll(e){
                if(this.allowScroll){
                    return;
                }else{
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            disableScroll(e){
                if(this.allowScroll){
                    return;
                }else{
                    e.preventDefault();
                }
            },
            enableScroll(e){
                return;
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
